// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3uNXO","ranges":"BmiRanges_ranges__25U0A"};